import { invoiceableLines, isEverythingInvoiced, tableEmptyMessages } from './invoiceableLines';
import type { InvoiceableService } from './invoiceableLines';
import { linkedServiceNames } from './linkedServiceNames';
import type { SoldAddOn, SoldLines } from '../types/agreements.types';

export type StillToInvoiceContent =
    | { everythingInvoiced: true }
    | {
          everythingInvoiced: false;
          services: InvoiceableService[];
          addOns: SoldAddOn[];
          emptyMessages: { services: string; addOns: string };
          serviceNames: Map<string, string>;
      };

export function stillToInvoiceContent(lines: SoldLines): StillToInvoiceContent {
    if (isEverythingInvoiced(lines)) return { everythingInvoiced: true };

    const { services, addOns } = invoiceableLines(lines);
    return {
        everythingInvoiced: false,
        services,
        addOns,
        emptyMessages: tableEmptyMessages(lines),
        serviceNames: linkedServiceNames(lines.services),
    };
}
